import { cacheService } from './CachedService';

const StyleCheckRegex = /display\:\snone/i;
const NamespacedTagNameRegex = /^(.+?):(.+?)/i;

/*
 * @class SimpleSvg
 * Simplified version of an SVG image
 * Concentrates only on what we need for ABB, removes hidden lines, metadata, defs
 * 
 */
class SimpleSvg {
  constructor( width, height, viewBox ) {
    this.width = width;
    this.height = height;
    this.viewBox = viewBox;
    this.elements = [];
  }
  setChildren( childElements ) {
    if ( !childElements ) {
      return;
    }

    for ( let i = 0; i < childElements.length; i++ ) {
      let elem = childElements[i];
      let style = elem.getAttribute && elem.getAttribute( 'style' ) || '';

      if ( !elem.getAttribute || elem.getAttribute( 'display' ) === 'none' ||
        elem.tagName === 'metadata' ||
        elem.tagName === 'defs' ||
        elem.tagName.match( NamespacedTagNameRegex ) ||
        style.match( StyleCheckRegex ) ) {
        continue;
      }

      this.elements.push( elem );
    }
  }
}

/*
 * @method getXmlDocumentFromString
 * @param xmlstring {string} the xml document that needs to be parsed
 * @returns a Xml DOM node that can be searched
 */
function getXmlDocumentFromString( xmlstring ) {
  if ( window.DOMParser ) {
    return new window.DOMParser().parseFromString( xmlstring, 'image/svg+xml' );
  }
  console.warn( 'no document parser was found!' );
}

/*
 * @method transform
 * @param httpresponse {object} the received http object from a get request
 * @returns a new SimpleSvg image containing the necessary data for rendering an image at the appropriate place
 */
function transform( httpresponse ) {
  let document = getXmlDocumentFromString( httpresponse.data ),
    svg = document.querySelector( 'svg' ),
    children, simpleSvg;

  // internet explorer or edge will be childNodes
  children = svg?.children || svg?.childNodes;
  simpleSvg = new SimpleSvg(
    svg.getAttribute( 'width' ),
    svg.getAttribute( 'height' ),
    svg.getAttribute( 'viewBox' )
  );
  simpleSvg.setChildren( children );
  return simpleSvg;
}

/*
 * @method transformImage
 * Caches a retrieved image so it doesn't have to be recreated each time it is wanted
 * @param {type} the url to the image that needs to be cached
 * @returns {transformImage} The image that is returned from the httpResponse
 */
function transformImage( image ) {
  if ( !transformImage[image] ) {
    transformImage[image] = cacheService.get( image ).then( response => transform( response ) );
  }
  return transformImage[image];
}

export const retrieve = image => transformImage( image );